import IconCard from "components/DynamicComponent/atoms/IconCard"

export default function IconCardOverlay({ blok }) {
  return (
    <section className="relative bg-white px-6 py-10 md:pt-20 lg:py-0">
      <div className="relative z-10 mx-auto flex max-w-screen-xl flex-col flex-wrap justify-between lg:-mt-16 lg:flex-row gap-8">
        {blok.cards.map((card) => (
          <IconCard key={card._uid} blok={card} />
        ))}
      </div>
    </section>
  )
}
